import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { FONT, PAPER_SIZE } from '../../types/enums';
import PDFUtils from '../../badge/utils/pdfUtils';
import moment from 'moment';
import React from 'react';
import { VisaDocumentProps } from '../types';
import { useVisaDocumentFR } from './hooks/useVisaDocumentFR';
import { TextWithFontCheck as TFC } from '../../common/components/textWithFontCheck/TextWithFontCheck';
import { registerFonts } from '../../badge/pdf/pdfDocument/pdfStyles';

const styles = StyleSheet.create({
  logo: {
    minWidth: '596px',
    maxWidth: '596px',
    minHeight: '86px',
    maxHeight: '86px',
    marginBottom: '10px'
  },
  container: {
    fontFamily: FONT.HELVETICA,
    paddingLeft: '3cm',
    paddingRight: '3cm',
    fontSize: '12px'
  },
  footer: {
    minWidth: '596px',
    maxWidth: '596px',
    minHeight: '295px',
    maxHeight: '295px',
    marginTop: 'auto'
  },
  alignLeft: {
    textAlign: 'left'
  },
  bold: {
    fontFamily: FONT.HELVETICA_BOLD
  },
  alignCenter: {
    textAlign: 'center'
  },
  marginBottom20: {
    marginBottom: 20
  },
  marginBottom10: {
    marginBottom: 10
  }
});

export const VisaDocumentAU: React.FC<VisaDocumentProps> = ({ event, person, company, logoSrc, footerSrc }) => {
  registerFonts();
  moment.locale('en');
  const { startDate, endDate, startDateDisplayYear } = useVisaDocumentFR(event.dates);

  return (
    <Document>
      <Page size={PAPER_SIZE.A4}>
        <Image style={styles.logo} src={PDFUtils.returnSrc(logoSrc)} />
        <View style={styles.container}>
          <Text style={[styles.alignLeft, styles.marginBottom20]}>Dear <TFC>{person.firstName}</TFC>,</Text>
          <Text style={[styles.alignCenter, styles.bold]}><TFC bold>{event.name}</TFC> {startDateDisplayYear}</Text>
          <Text style={[styles.alignCenter, styles.bold]}><TFC bold>{`${event.venue}, ${event.city}, ${event.country}`}</TFC></Text>
          <Text style={[styles.alignCenter, styles.bold, styles.marginBottom20]}>{startDate} - {endDate}</Text>
          <Text style={styles.marginBottom20}>I write to provide you with a letter of invitation to exhibit at the
            above-mentioned event for
            which we are the organising company.</Text>
          <Text style={styles.marginBottom20}>All expenses including travel, visas, hotels and incidentals are to your
            own account and will not
            be settled by the organisers Reed Exhibitions Pty Ltd.</Text>
          <Text style={styles.marginBottom20}>Please present this letter of invitation when lodging your visa
            application at the Australian visa
            office overseas nearest to your current place of residence.</Text>
          <Text style={styles.bold}>Country of Passport : <TFC bold>{person.passportData.country}</TFC></Text>
          <Text style={styles.bold}>Passport Number : <TFC bold>{person.passportData.passportNumber}</TFC></Text>
          <Text style={styles.bold}>Country of Residence : <TFC bold>{person.passportData.country}</TFC></Text>
          <Text style={styles.bold}>Date of Birth : {moment(person.passportData.dateOfBirth).format('DD MMMM YYYY')}</Text>
          <Text style={styles.bold}>Last Name : <TFC bold>{person.lastName}</TFC></Text>
          <Text style={styles.bold}>First Name: <TFC bold>{person.firstName}</TFC></Text>
          <Text style={styles.bold}>Applicant Company Name : <TFC bold>{company.name}</TFC></Text>
          <Text style={[styles.bold, styles.marginBottom20]}>Applicant Contact : <TFC bold>{person.email}</TFC></Text>
          <Text style={styles.marginBottom10}>We look forward to seeing you at the show.</Text>
          <Text>Yours sincerely,</Text>
        </View>
        <Image style={styles.footer} src={PDFUtils.returnSrc(footerSrc)} />
      </Page>
    </Document>
  );
};
